import {isNotNil} from 'ramda';

import {VinDecoderResponseBody} from '@dms/api/vehicle';

const hasValue = (value: unknown): boolean => {
  if (Array.isArray(value)) {
    return value.length > 0;
  }

  return isNotNil(value) && value !== '';
};

export const hasMeaningfulVinDecodeData = (
  decodedData?: VinDecoderResponseBody | null
): boolean => {
  if (!decodedData) {
    return false;
  }

  if (isNotNil(decodedData.decodedCount) && decodedData.decodedCount > 0) {
    return true;
  }

  const {
    decodingStatus: _decodingStatus,
    decodedCount: _decodedCount,
    ...vehicleFields
  } = decodedData;

  return Object.values(vehicleFields).some(hasValue);
};
